<script setup lang="ts">
import { onMounted } from 'vue'
import { updateUnreadMessages, useUnreadMessages } from '@/composables/unreadMessages'

const mitteilungen = useUnreadMessages()

onMounted(() => {
    updateUnreadMessages()
})

</script>

<template>
    <v-menu offset-y>
        <template v-slot:activator="{ props }">
            <v-btn v-bind="props" rounded color="green lighten-3 white--text">
                <v-avatar size="24" left color="green darken-5">
                    {{ mitteilungen.length || 0 }}
                </v-avatar>
                <span class="ml-2 d-none d-md-inline">{{
                    mitteilungen.length === 1 ? $t('new_message') : $t('new_messages')
                }}</span>
            </v-btn>
        </template>
        <v-list two-line subheader color="grey-lighten-4 elevation-2">
            <v-list-item
                v-for="mitteilung in mitteilungen"
                :key="mitteilung.id || 'foo'"
                @click="$emit('mitteilungclick', mitteilung)"
            >
                <template #append>
                    <v-icon>far fa-envelope</v-icon>
                </template>
                {{ mitteilung?.created?.format('DD.MM.YYYY HH:mm') }} |
                {{ mitteilung.gesuch_nummer }}
                <v-list-item-title>{{ mitteilung.subject }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
